import { render, staticRenderFns } from "./BlockedVisitors.vue?vue&type=template&id=563b0425&scoped=true"
import script from "./BlockedVisitors.vue?vue&type=script&lang=js"
export * from "./BlockedVisitors.vue?vue&type=script&lang=js"
import style0 from "./BlockedVisitors.vue?vue&type=style&index=0&id=563b0425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b0425",
  null
  
)

export default component.exports